import React, {Component} from 'react';
import { View, Text} from 'react-native';

import ff from './ff';
import cf from './cf';
import ce from './ce';
import ic from './ic';
import bf from './bf';
//import iv from './iv';

import df from './df_20211115';

import c00v from './c00v_20211024';
import c10v1a from './c10v1a';

export default class c00v1 extends c00v { // ログイン画面

$id_stss = {
  s_id: '',
  s_pwd: '',
  sn_step: 10,
};

static cd_stgs = {
};

$ilp_loadLists = () => [
];

_op_clr = () => new Promise( _o_end1 => {
  let _d = 
    (global.t?.state.sgcd_cmnStgs?.c01rt21i == 30) ? // s_id を初期化しない
      {
        s_pwd: '',
        sn_step: 10,
      }
    : bf.i(global.t?.state.sgcd_cmnStgs?.c01rt21i, [10, 20]) ?
      {
          s_id: '',
          s_pwd: '',
          sn_step: 10,
      }
    : null;

  if (ff.f(_d)) {
    cf.myRN_setStt(_d)
    .then(_o_end1);
  }
  else {
    _o_end1();
  }
});

render() {

//ff.l('56: {}'.f(global.t?.state.sgcd_cmnStgs?.c01rt21i));
//ff.l('56: {}'.f(global.t?.state.sgcd_cmnStgs?.c01rt11i));

  return (
    ce.c(ce.RootDtl, 
    /* ----------------------------------------------------------------------------------------------------
    確認コード認証：管理用・団体用
    ---------------------------------------------------------------------------------------------------- */
    ( global.t?.state.sgcd_cmnStgs?.c01rt21i == 10 ) ? 
    {
      d_hdrs: {
        d_lefts: {
          b_vsb: false,
        }
      },
      d_bdys: {

        l_clds: [
          
          ce.c(ce.Pnl, {
            key: -10,
            b_vsb: (global.t?.state.sn_step == 10) ? true : false,
            d_btms: {
              l_clds: [
                ce.c(ce.Msg, {
                  key: -5,
                  pfx:`＊ 地域ケアプラザ施設管理支援システム　C-サポート ＊`,
                  d_stlCtas: {
                    marginBottom: ic.s(1),
                  },
                  d_stlPfxs: {
                    textAlign: 'center',
                    fontSize: ic.s(1),
                  },
                }),
              ]
            },
            d_bdys: {
              l_clds: [

                ce.c(ce.Img, {
                  key: -3,
                  uri: `${ic.g_url2}/login-head.jpeg`,
                  d_stlCtas: {
                    height: ic.gn_w / 1920 * 130,
                    width: ic.gn_w,
                  },
                  d_stlImgs: {
                    height: ic.gn_w / 1920 * 130,
                    width: ic.gn_w,
                  }
                }),

                ce.c(ce.Msg, {
                  key: -5,
//                   pfx:`${global.t?.state.sgcd_cmnStgs?.c20r_pfx ?? ''}　施設予約管理`,
                  pfx:
                    (global.t?.state.sgcd_cmnStgs?.c01rt11i == 10) ? 
                      `${global.t?.state.sgcd_cmnStgs?.c20r_pfx ?? ''}　施設利用予約`
                    : `${global.t?.state.sgcd_cmnStgs?.c20r_pfx ?? ''}　施設予約管理`,
                   b_vsb: (global.t?.state.sgcd_cmnStgs?.c20r_pfx) ? true : false,
                  d_stlCtas: {
                    marginTop: ic.s(2),
                  },
                  d_stlPfxs: {
                    textAlign: 'center',
                    fontSize: ic.s(1.6),
                    fontWeight: 'bold',
                    color: ic.o_getCcd('d'),
                  },
                }),

                global.t?.state.sgcd_stgs?._00080100 ?
                ce.c(ce.Box, {
                  key: -7,
                  d_stlCtas :{
                    marginTop: ic.s(2),
                    width: ic.gn_bdyW,
                    maxWidth: ic.gn_minBdyW * 2,
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderColor: 'black',
                    borderWidth: ic.b(0.5),
                    padding: ic.s(0.5),
                  },
                }, [
                  ce.c(ce.Msg, {
                    key: -10,
                    pfx: global.t?.state.sgcd_stgs?._00080100,
//                    pfx: `只今準備中です。\nシステムでの予約は\nしばらくお待ちください。`,
//                    pfx: `只今準備中です。`,
                    stlCta: {
//                      height: ic.s(1) * ((ic.g_dvcMode == 's') ? 1 : 2),
                      width: ic.gn_minBdyW,
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                      marginBottom: ic.m(1),
                    },
                    stlPfx: {
                      textAlign: 'center',
                    },
                  }),
                ])
                : null,

//                ff.f(global.t?.state.sgcd_stgs?._00080200) == false || global.t?.state.sgcd_stgs?._00080200 == 10 ?
                global.t?.state.sgcd_stgs?._00080200 != 0 ?
                  ce.c(ce.Box, {
                    key: -10,
                    d_stlCtas: {
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                    },
                  }, [
                    ce.c(ce.Msg, {
                      key: -10,
                      pfx:`▼登録したメールアドレスを入力し、［送る］ボタンを押してください。\nログイン用「確認コード」が記されたメールが、このアドレス宛に届きますので、ご確認ください。`,
                      d_stlCtas: {
                        marginTop: ic.s(2),
                      },
                      d_stlPfxs: {
                        textAlign: 'center',
                      },
                    }),

                    ce.c(ce.Inp, {
                      key: -20,
                      pfx: 'メールアドレス',
                      state: 's_id',
                      b_edit: true,
//                      b_trim: true,
                      n_col: 20,
                      d_stlCtas: {
                        marginTop: ic.s(1),
                      }
                    }),

                    ce.c(ce.Btn, {
                      key: -30,
                      pfx:'送る',
                      o_onPrs: ()=>{
                        cf.s();
                        const _id = ff.myCM_cnv('trim', ff.myCM_cnv('lwr', String(global.t?.state.s_id).replace(/ /g, '')));
//ff.l('c00v1 202: "{}"'.f(_id))
                        cf.myRN_setStt({
//                          s_id: ff.myCM_cnv('lwr', String(global.t?.state.s_id).replace(/ /g, '')),
//                          s_id: ff.myCM_cnv('trim', ff.myCM_cnv('lwr', String(global.t?.state.s_id).replace(/ /g, ''))),
                          s_id: _id,
                        })
//                        if (true) cf.myCB_call_code(global.t?.state.s_id);
//                        if (true) cf.myCB_call_code(ff.myCM_cnv('trim', global.t?.state.s_id));
                        if (true) cf.myCB_call_code(_id);
                        cf.myRN_setStt({ // 確認コードの確認
                          sn_step: '20',
                        })
                        .then(() => {
                          cf.h();
                        });
                      },
                      d_stlCtas: {
                        marginTop: ic.s(2),
                      }
                    }),

                    ce.c(ce.Box, {
                      key: -40,
                    }, [
                      ce.c(ce.Msg, {
                        key: -10,
                        b_vsb: (global.t?.state.sb_cookie == true) ? false : true,
                        pfx: '※ ブラウザのクッキーを有効にしてください。',
                        d_stlCtas: {
                          marginTop: ic.s(2),
                        },
                        d_stlPfxs: {
                          fontSize: ic.gn_fontSizeSml,
                          color: ic.g_ccdRN,
                        },
                      }),

                      ce.c(ce.Msg, {
                        key: -20,
                        b_vsb: true,
                        pfx: '※ 指定したメールアドレス宛に確認コードが送信されない場合は、使用しているメールアプリや通信キャリアの受信設定もご確認ください。',
                        d_stlCtas: {
                          marginTop: ic.s(2),
                        },
                        d_stlPfxs: {
                          fontSize: ic.gn_fontSizeSml,
                        },
                      }),

                      ce.c(ce.Msg, {
                        key: -30,
                        b_vsb: true,
                        pfx:
                          (global.t?.state.sgcd_cmnStgs?.c01rt11i == 10) ? 
                            '※ １団体で複数のメールアドレスが登録されている場合でも、確認コードは入力したアドレスのみ届きます。'
                          : '※ 正しい確認コードを入力したにも関わらずログインに失敗する場合は、システムに登録されているメールアドレスもご確認ください。',
                        d_stlCtas: {
                          marginTop: ic.s(1),
                        },
                        d_stlPfxs: {
                          fontSize: ic.gn_fontSizeSml,
                        },
                      })
                    ])
                  ])
                : null,

              ],
            },
          }),

          ce.c(ce.Pnl, {
            key: -20,
            b_vsb: (global.t?.state.sn_step == 20) ? true : false,
            d_btms: {
              l_clds: [
                ce.c(ce.Msg, {
                  key: -5,
                  pfx:`＊ 地域ケアプラザ施設管理支援システム　C-サポート ＊`,
                  d_stlCtas: {
                    marginBottom: ic.s(1),
                  },
                  d_stlPfxs: {
                    textAlign: 'center',
                    fontSize: ic.s(1),
                  },
                }),
              ]
            },
            d_bdys: {

              l_clds: [

                ce.c(ce.Img, {
                  key: -3,
                  uri: `${ic.g_url2}/login-head.jpeg`,
                  d_stlCtas: {
                    height: ic.gn_w / 1920 * 130,
                    width: ic.gn_w,
                  },
                  d_stlImgs: {
                    height: ic.gn_w / 1920 * 130,
                    width: ic.gn_w,
                  }
                }),

                ce.c(ce.Msg, {
                  key: -5,
                  pfx:
                    (global.t?.state.sgcd_cmnStgs?.c01rt11i == 10) ? 
                      `${global.t?.state.sgcd_cmnStgs?.c20r_pfx ?? ''}　施設利用予約`
                    : `${global.t?.state.sgcd_cmnStgs?.c20r_pfx ?? ''}　施設予約管理`,
                   b_vsb: (global.t?.state.sgcd_cmnStgs.c20r_pfx) ? true : false,
                  d_stlCtas: {
                    marginTop: ic.s(2),
                  },
                  d_stlPfxs: {
                    textAlign: 'center',
                    fontSize: ic.s(1.6),
                    fontWeight: 'bold',
                    color: ic.o_getCcd('d'),
                  },
                }),

                ce.c(ce.Msg, {
                  key: -10,
                  pfx: `▼前画面で入力したメールアドレス「${global.t?.state.s_id}」宛に送信された確認コードを入力してください。\n※ 入力はメールの受け取りから30分以内です。\n※ 30分を過ぎると、新しい確認コードが必要になりますので、ご注意ください。\n※　セキュリティ強化のため、操作を行わず1時間をすぎると自動的にログアウトします。操作を再開する場合は、改めて発行した確認コードを入力する必要があります。`,
                  d_stlCtas: {
                    marginTop: ic.s(2),
                  },
                  d_stlPfxs: {
                    textAlign: 'center',
                  },
                }),

                ce.c(ce.Inp, {
                  key: -20,
                  state: 's_pwd',
                  b_edit: true,
//                  b_trim: true,
                  pfx: '確認コード',
                  d_stlCtas: {
                    marginTop: ic.s(1),
                  }
                }),

                ce.c(ce.Box, {
                  key: -30,
                  b_row: true,
                  d_stlCtas: {
                    width: ic.gn_minBdyW,
                    justifyContent: 'space-around',
                  },
                }, [
                  ce.c(ce.Btn, {
                    key: -10,
                    pfx:'戻る',
                    o_onPrs: ()=>{
                      cf.myRN_setStt({
                        sn_step: 10,
                      })
                    },
                    d_stlCtas: {
                      marginTop: ic.s(2),
                    },
                    d_stlBtns: {
                      backgroundColor: ic.g_ccdHN,
                      borderColor: ic.g_ccdHN,
                    },
                  }),

                  ce.c(ce.Btn, {
                    key: -20,
                    pfx: '送る',
                    o_onPrs: async ()=>{
                      /* **************************************************
                      ログインできない場合、DB と サービスを再起動
                      sudo systemctl restart postgressql-12
                      . ./r.sh
                      ************************************************** */
                      cf.s();
                      let _d_ress = null;
                      //if ( ic.gb_dev == true ) {
                      if ( false ) {
                        if ( global.t?.state.s_pwd == '519832' ) {
                          _d_ress = {
                            n_sts: 1,
                            tkn: 'debug',
                          };
                        } 
                        else {
                          _d_ress = {
                            n_sts: 0,
                          };
                        }
                      }
                      else {
                        //ff.l('c00v 363: here');
  //                      _d_ress = await cf.myCB_call_cnf(global.t?.state.s_id, global.t?.state.s_pwd)
                        _d_ress = await cf.myCB_call_cnf(ff.myCM_cnv('trim', global.t?.state.s_id), ff.myCM_cnv('trim', global.t?.state.s_pwd))
                      // ff.l('c00v 365: {}'.f(_d_ress));
                      };

                      //ff.l('c00v 366: {}'.f(_d_ress));
                      if (_d_ress.n_sts == 1) { // 新規登録の場合
                        //
                        cf.myRN_saveCmnStgs({
                          tkn: _d_ress.tkn,
                        })
                        .then(() => { // c00r での認証を踏まえ、c10r を取得・設定
                          let _cnd = `
                            COALESCE(c10rcz1i, 10) <> 0
                            AND c10rb21f = ${global.t?.state.sgcd_cmnStgs.c20r_fst}
                            AND c10rt11i = ${global.t?.state.sgcd_cmnStgs.c01rt11i}
                          `;
  //                        if (global.t?.state.sgcd_cmnStgs.c01rt21i == 10) _cnd += ` AND c10ri11s = "${global.t?.state.s_id}"` // メール認証
  //                        if (global.t?.state.sgcd_cmnStgs.c01rt21i == 20) _cnd += ` AND c10rc01s = "${global.t?.state.s_id}"` // ID認証
                          if (global.t?.state.sgcd_cmnStgs.c01rt21i == 10) _cnd += ` AND c10ri11s = "${ff.myCM_cnv('trim', global.t?.state.s_id)}"` // メール認証
                          if (global.t?.state.sgcd_cmnStgs.c01rt21i == 20) _cnd += ` AND c10rc01s = "${ff.myCM_cnv('trim', global.t?.state.s_id)}"` // ID認証
                          //ff.l('c00v 371: {}'.f(_cnd));
                          cf.myCB_call_slc({ // 通らない場合、node のログ、firewall の port を確認 
                            ctr: 'nlm', 
                            elm: 'c10r', 
                            n_dms: 2, 
                            cnd: _cnd
                          })
                          .then((_d_c10rs) =>{
                            //ff.l('c00v 379: {}'.f(_d_c10rs))
                            if (bf.f(_d_c10rs)) {
                              cf.h();
                              c00v1._setC10rs(_d_c10rs, true);                            
                            }
                            else {
                              ff.myCM_wait(10)
                              .then(() => {
                                alert('認証に失敗しました。最初からお願いします。')
                                cf.h();
                                global.t?._op_clr();
                              });
                            };
                          });
                        });
                      }
                      else {
                        ff.myCM_wait(10)
                        .then(() => {
                          alert('認証に失敗しました。最初からお願いします。')
                          cf.h();
                          global.t?._op_clr();
                        });
                      };
                    },
                    d_stlCtas: {
                      marginTop: ic.s(2),
                    }
                  })
                ]),
              ],
            },
          }),

        ],
      },
      }
    /* ----------------------------------------------------------------------------------------------------
    パスワード認証：スタッフ様
    ---------------------------------------------------------------------------------------------------- */
    : ( global.t?.state.sgcd_cmnStgs?.c01rt21i == 20 ) ? 
    {
      d_hdrs: {
        d_lefts: {
          b_vsb: false,
        }
      },
      d_bdys: {
        l_clds: [
          
          ce.c(ce.Pnl, {
            key: -10,
            b_vsb: (global.t?.state.sn_step == 10) ? true : false,
            d_btms: {
              l_clds: [
                ce.c(ce.Msg, {
                  key: -5,
                  pfx:`＊ 地域ケアプラザ施設管理支援システム　C-サポート ＊`,
                  d_stlCtas: {
                    marginBottom: ic.s(1),
                  },
                  d_stlPfxs: {
                    textAlign: 'center',
                    fontSize: ic.s(1),
                  },
                }),
              ]
            },
            d_bdys: {
              l_clds: [

                ce.c(ce.Img, {
                  key: -10,
                  uri: `${ic.g_url2}/login-head.jpeg`,
                  d_stlCtas: {
                    height: ic.gn_w / 1920 * 130,
                    width: ic.gn_w,
                  },
                  d_stlImgs: {
                    height: ic.gn_w / 1920 * 130,
                    width: ic.gn_w,
                  }
                }),

                ce.c(ce.Msg, {
                  key: -20,
                   pfx:`${global.t?.state.sgcd_cmnStgs?.c20r_pfx ?? ''}　施設予約管理【管理者用】`,
                   b_vsb: (global.t?.state.sgcd_cmnStgs?.c20r_pfx) ? true : false,
                  d_stlCtas: {
                    marginTop: ic.s(2),
                  },
                  d_stlPfxs: {
                    textAlign: 'center',
                    fontSize: ic.s(1.6),
                    fontWeight: 'bold',
                    color: ic.o_getCcd('d'),
                  },
                }),

                ce.c(ce.Msg, {
                  key: -30,
//                  pfx:`▼登録したログインIDとパスワードを入力し、［送る］ボタンを押してください。`,
                  pfx:`▼登録したログインIDとパスワードを入力し、ログインボタンを押してください。`,
                  d_stlCtas: {
                    marginTop: ic.s(2),
                  },
                  d_stlPfxs: {
                    textAlign: 'center',
                  },
                }),

                ce.c(ce.Inp, {
                  key: -40,
                  pfx: 'ログインID',
                  state: 's_id',
                  b_edit: true,
//                  b_trim: true,
                  n_col: 20,
                  d_stlCtas: {
                    marginTop: ic.s(1),
                  }
                }),

                ce.c(ce.Inp, {
                  key: -50,
                  pfx: 'パスワード',
                  state: 's_pwd',
                  b_edit: true,
                  b_pwd: true,
//                  b_trim: true,
                  n_col: 20,
                  d_stlCtas: {
                    marginTop: ic.s(1),
                  }
                }),

                ce.c(ce.Btn, {
                  key: -60,
//                  pfx:'送る',
                  pfx: 'ログイン',
                  o_onPrs: async ()=>{
                    /* **************************************************
                    ログインできない場合、DB と サービスを再起動
                    sudo systemctl restart postgressql-12
                    . ./r.sh
                    ************************************************** */
                    cf.s();
                    let _d_ress = null;

                    if ( ic.gb_dev == true ) {
                      if ( ff.myCM_cnv('trim', global.t?.state.s_pwd) == '519832' ) {
                        _d_ress = {
                          n_sts: 1,
                          tkn: 'debug',
                        };
                      } 
                      else {
                        _d_ress = {
                          n_sts: 0,
                        };
                      }
                    }
                    else {
                      _d_ress = { // 暫定
                        n_sts: 1,
                        tkn: 'debug',
                      };
                    };

                    if (_d_ress.n_sts == 1) { // 新規登録の場合
                      //
                      cf.myRN_saveCmnStgs({
                        tkn: _d_ress.tkn,
                      })
                      .then(() => { // c00r での認証を踏まえ、c10r を取得・設定
                        let _cnd = `
                          COALESCE(c10rcz1i, 10) <> 0
                          AND c10rb21f = ${global.t?.state.sgcd_cmnStgs.c20r_fst}
                          AND c10rt11i = ${global.t?.state.sgcd_cmnStgs.c01rt11i}
                        `;
//                        _cnd += ` AND c10rc01s = "${global.t?.state.s_id}"`
//                        if ( ic.gb_dev == false ) _cnd += ` AND c10rc02s = "${ff.myCM_cnv('trim', global.t?.state.s_pwd)}"`
                        _cnd += ` AND c10rc01s = "${ff.myCM_cnv('trim', global.t?.state.s_id)}"`
                        if ( ic.gb_dev == false ) _cnd += ` AND c10rc02s = "${ff.myCM_cnv('trim', global.t?.state.s_pwd)}"`
                        //ff.l('c00v 581: {}'.f(_cnd));
                        cf.myCB_call_slc({ // 通らない場合、node のログ、firewall の port を確認 
                          ctr: 'nlm', 
                          elm: 'c10r', 
                          n_dms: 2, 
                          cnd: _cnd
                        })
                        .then((_d_c10rs) =>{
                          if (ic.gb_dbg) ff.l('c00v 480: {}'.f(_d_c10rs))
                          if (bf.f(_d_c10rs)) {
                            cf.h();
                            c00v1._setC10rs(_d_c10rs, true);                            
                          }
                          else {
                            ff.myCM_wait(5)
                            .then(() => {
                              alert('認証に失敗しました。最初からお願いします。')
                              cf.h();
                              global.t?._op_clr();
                            });
                          };
                        });
                      });
                    }
                    else {
                      ff.myCM_wait(5)
                      .then(() => {
                        alert('認証に失敗しました。最初からお願いします。')
                        cf.h();
                        global.t?._op_clr();
                      });
                    };
                  },
                  d_stlCtas: {
                    marginTop: ic.s(2),
                  }
                }),

                ce.c(ce.Box, {
                  key: -70,
                }, [
                  ce.c(ce.Msg, {
                    key: -10,
                    b_vsb: (global.t?.state.sb_cookie == true) ? false : true,
                    pfx: '※ ブラウザのクッキーを有効にしてください。',
                    d_stlCtas: {
                      marginTop: ic.s(2),
                    },
                    d_stlPfxs: {
                      fontSize: ic.gn_fontSizeSml,
                      color: ic.g_ccdRN,
                    },
                  }),

                  ce.c(ce.Msg, {
                    key: -30,
                    b_vsb: true,
//                    pfx: '※ 正しい確認コードを入力したにも関わらずログインに失敗する場合は、システムに登録されているログインID・パスワードもご確認ください。',
                    pfx: '※ パスワードが不明な場合はシステム管理者までお問い合わせください。',
                    d_stlCtas: {
                      marginTop: ic.s(2),
                      flexDirection : 'column',
                      justifyContent: 'flex-start',
                      alignItems: 'center',
                    },
                    d_stlPfxs: {
                      fontSize: ic.gn_fontSizeSml,
                    },
                  })
                ])

              ],
            },
          }),

        ],
      },
      }
    /* ----------------------------------------------------------------------------------------------------
    パスワード認証：団体初回登録用
    ---------------------------------------------------------------------------------------------------- */
    : ( global.t?.state.sgcd_cmnStgs?.c01rt21i == 30 ) ? 
    {
      d_hdrs: {
        d_lefts: {
          b_vsb: false,
        }
      },
      d_bdys: {
        d_stlCtas: {
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          backgroudColor: 'black',                
        },
        l_clds: [
          
          ce.c(ce.Pnl, {
            key: -10,
            b_vsb: (global.t?.state.sn_step == 10) ? true : false,
            d_btms: {
              l_clds: [
                ce.c(ce.Msg, {
                  key: -5,
                  pfx:`＊ 地域ケアプラザ施設管理支援システム　C-サポート ＊`,
                  d_stlCtas: {
                    marginBottom: ic.s(1),
                  },
                  d_stlPfxs: {
                    textAlign: 'center',
                    fontSize: ic.s(1),
                  },
                }),
              ]
            },
            d_bdys: {
              d_stlCtas: {
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                backgroudColor: 'black',                
              },
              l_clds: [

                ce.c(ce.Img, {
                  key: -10,
                  uri: `${ic.g_url2}/login-head.jpeg`,
                  d_stlCtas: {
                    height: ic.gn_w / 1920 * 130,
                    width: ic.gn_w,
                  },
                  d_stlImgs: {
                    height: ic.gn_w / 1920 * 130,
                    width: ic.gn_w,
                  }
                }),

                ce.c(ce.Msg, {
                  key: -20,
                   pfx:`${global.t?.state.sgcd_cmnStgs?.c20r_pfx ?? ''}　施設予約管理`,
                   b_vsb: (global.t?.state.sgcd_cmnStgs?.c20r_pfx) ? true : false,
                  d_stlCtas: {
                    marginTop: ic.s(2),
                  },
                  d_stlPfxs: {
                    textAlign: 'center',
                    fontSize: ic.s(1.6),
                    fontWeight: 'bold',
                    color: ic.o_getCcd('d'),
                  },
                }),

                ce.c(ce.Msg, {
                  key: -30,
                  pfx:`施設予約用メールアドレスの登録`,
                  b_vsb: (global.t?.state.sgcd_cmnStgs.c20r_pfx) ? true : false,
                  d_stlCtas: {
                    marginTop: ic.s(2),
                  },
                  d_stlPfxs: {
                    textAlign: 'center',
                    fontSize: ic.s(1.2),
                    fontWeight: 'bold',
                  },
                }),

                ce.c(ce.Msg, {
                  key: -40,
                  pfx:`別紙のメールアドレス登録用確認コードを入力し、送るボタンを押してください。`,
                  d_stlCtas: {
                    marginTop: ic.s(2),
                  },
                  d_stlPfxs: {
                    textAlign: 'center',
                  },
                }),

                ce.c(ce.Inp, {
                  key: -50,
                  pfx: 'メールアドレス登録用確認コード',
                  state: 's_pwd',
                  b_edit: true,
                  b_pwd: true,
//                  b_trim: true,
                  n_col: 20,
                  d_stlCtas: {
                    marginTop: ic.s(1),
                  }
                }),

                ce.c(ce.Btn, {
                  key: -60,
                  pfx:'送る',
                  o_onPrs: async ()=>{
                    /* **************************************************
                    ログインできない場合、DB と サービスを再起動
                    sudo systemctl restart postgressql-12
                    . ./r.sh
                    ************************************************** */
                    cf.s();
                    let _d_ress = null;
                    if ( false ) {
                      if ( global.t?.state.s_pwd == '519832' ) {
                        _d_ress = {
                          n_sts: 1,
                          tkn: '-',
                        };
                      } 
                      else {
                        _d_ress = {
                          n_sts: 0,
                        };
                      }
                    }
                    else {
//                      let _fst = ff.n(global.t?.state.s_id);
                      let _fst = ff.n(ff.myCM_cnv('trim', global.t?.state.s_id));
//ff.l('c00v1 923: {}, {}, {}'.f(_fst, global.t?.state.s_pwd, ff.myCM_cnv('chkPwd', {n_nbr: _fst, pwd: global.t?.state.s_pwd})))
//                      if ( ff.myCM_cnv('chkPwd', {n_nbr: _fst, pwd: global.t?.state.s_pwd}) ) {
//                      if ( ff.myCM_cnv('chkPwd', {n_nbr: _fst, pwd: global.t?.state.s_pwd}) ) {
                      if ( ff.myCM_cnv('chkPwd', {n_nbr: _fst, pwd: ff.myCM_cnv('trim', global.t?.state.s_pwd)}) ) {
                        _d_ress = {
                          n_sts: 1,
                          tkn: '-',
                        };
                      } 
                      else {
                        _d_ress = {
                          n_sts: 0,
                        };
                      }
                    };

//ff.l('c00v1 937: {}'.f(_d_ress.n_sts))
                    if (_d_ress.n_sts == 1) { // 新規登録の場合
                      //
                      cf.myRN_saveCmnStgs({
                        tkn: _d_ress.tkn,
                      })
                      .then(() => { // c00r での認証を踏まえ、c10r を取得・設定
/*
                        let _cnd = `
                          COALESCE(c10rcz1i, 10) <> 0
                          AND c10rb21f = ${global.t?.state.sgcd_cmnStgs.c20r_fst}
                          AND c10rt11i = ${global.t?.state.sgcd_cmnStgs.c01rt11i}
                          AND _key = (SELECT MIN(_key) FROM t_c10r WHERE ${cf.c('c10r', `t_c10r.c10rb31f = ${global.t?.state.s_id})`, false, false)}
                        `;
*/
                        let _cnd = `
                          COALESCE(c10rcz1i, 10) <> 0
                          AND c10rb21f = ${global.t?.state.sgcd_cmnStgs.c20r_fst}
                          AND c10rt11i = ${global.t?.state.sgcd_cmnStgs.c01rt11i}
                          AND _key = (SELECT MIN(_key) FROM t_c10r WHERE ${cf.c('c10r', `t_c10r.c10rb31f = ${ff.myCM_cnv('trim', global.t?.state.s_id)})`, false, false)}
                        `;
//ff.l('c00v1 950: {}'.f(_cnd));
                        cf.myCB_call_slc({ // 通らない場合、node のログ、firewall の port を確認 
                          ctr: 'nlm', 
                          elm: 'c10r', 
                          n_dms: 2, 
                          cnd: _cnd
                        })
                        .then((_d_c10rs) =>{
//ff.l('c00v1 958: {}'.f(_d_c10rs));
                          if (bf.f(_d_c10rs)) {
//ff.l('c00v1 960: here');
                            cf.h();
                            c00v1._setC10rs(_d_c10rs, false)
                            .then(() => {
                              let _d_pageInfs = {
                                sgc_pageRole: 'mmb1',
                                sgc_pageName: 'c30v3a',
                                sgc_pageMode: 'show',
                              };
                              cf.myRN_move_fwd(_d_pageInfs);
                            })
                          }
                          else {
//ff.l('c00v1 973: here');
                            ff.myCM_wait(10)
                            .then(() => {
                              alert('認証に失敗しました。最初からお願いします。')
                              cf.h();
                              global.t?._op_clr();
                            });
                          };
                        });
                      });
                    }
                    else {
                      ff.myCM_wait(10)
                      .then(() => {
                        alert('認証に失敗しました。最初からお願いします。')
                        cf.h();
                        global.t?._op_clr();
                      });
                    };
                  },
                  d_stlCtas: {
                    marginTop: ic.s(2),
                  }
                }),

                ce.c(ce.Box, {
                  key: -70,
                }, [
                  ce.c(ce.Msg, {
                    key: -10,
                    b_vsb: (global.t?.state.sb_cookie == true) ? false : true,
                    pfx: '※ ブラウザのクッキーを有効にしてください。',
                    d_stlCtas: {
                      marginTop: ic.s(2),
                    },
                    d_stlPfxs: {
                      fontSize: ic.gn_fontSizeSml,
                      color: ic.g_ccdRN,
                    },
                  }),

                ])

              ],
            },
          }),

        ],
      },
    }
    : null
    )
  )
};

}
/*
 Copyright 2020 Yukio Shinohara All rights reserved.
 */
